export const array_sum = (values: number[]): number => {
  if (!values) {
    return 0;
  }

  return values.reduce((acc, a) => acc + a, 0);
};
